<template>
  <div class="gallery">
    <figure
      v-for="(image, idx) in imagesArray"
      :key="idx"
      @click="clicked(idx)"
      class="gallery__image-containet"
    >
      <img :src="image.url" alt="rizes-house" />
      <figcaption>{{ image.caption }}</figcaption>
    </figure>
  </div>
</template>

<script>
export default {
  name: 'BaseGalleryHorizontal',
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    clicked(idx) {
      // return the index oof the image that was clicked
      this.$emit('image-idx', idx);
    },
  },
  computed: {
    imagesArray() {
      return this.images.map((img) => {
        if (img.caption === undefined) {
          return { url: img.url, caption: '' };
        }

        return { url: img.url, caption: img.caption };
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.gallery {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  figure {
    position: relative;

    figcaption {
      padding: 2px 4px;
      color: white;
      font-family: var(--font-main);
      font-size: 10px;
      background-color: rgba(128, 128, 128, 0.4);
      position: absolute;
      bottom: 4px;
      right: 4px;
    }

    img {
      width: 250px;
      height: 167px;
      object-fit: cover;
      border-radius: 4px;
    }
  }
}

/***** MEDIA QUERIES *****/
@media (max-width: 900px) {
  .gallery {
    justify-content: center;

    figure {
      margin-right: 12px;
      margin-bottom: 8px;
    }
  }
}
</style>
